export default "__VITE_ASSET__VvbWV5b7__"